<ng-rate-results
  *ngIf="(store$ | async) as store"
  [data]="store.result"
  [loading]="store.loading"
  [displayResults]="store.displayResults"
  (clearAllRateData)="clearAllRateData()"
>
</ng-rate-results>
